import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ImageDirective } from './image.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ImageDirective],
  exports: [ImageDirective]
})
export class ImageModule {}
